import { render, staticRenderFns } from "./accordion.vue?vue&type=template&id=a78c6398&scoped=true&lang=pug&"
import script from "./accordion.vue?vue&type=script&lang=js&"
export * from "./accordion.vue?vue&type=script&lang=js&"
import style0 from "./accordion.vue?vue&type=style&index=0&id=a78c6398&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78c6398",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsAccordion: require('/home/ubuntu/nuxt/bonkers/releases/20230322165259/components/widgets/accordion.vue').default})
